import React from 'react';
import './App.css';
import Pop from './assets/pop.png';
import './WorkExperience.css'
import Notification from './assets/notifications.png';
import Math from './assets/math.png';
import PairProgram from './assets/pairProgramming.png';
import iOSmacOS from './assets/iOSmacOS.png';
import iphoneMap from './assets/iphoneMap.png'


function WorkExperience() {
   return (
      <div className="wrapper"> 
      <div className="workExperience">
         


         <h1 className="sectionHeading" >experience</h1>

         <div className="oneExperience">

         <div className="picDiv">
            <img src={iphoneMap} className="imgHolder"/>
         </div>
         <div className="contentDiv">
            <h2>Software Engineer Intern</h2>
            <h3>Apple</h3>
            <ul>
            <li>Worked on the iOS Vision Accessibility to build a feature for the Magnifier App using Nearby Interaction</li>
            </ul>
         </div>
         </div>

         <div className="picDiv">
            <img src={iOSmacOS} className="imgHolder"/>
         </div>
         <div className="contentDiv">
            <h2>Software Engineer Intern</h2>
            <h3>Microsoft</h3>
            <ul>
            <li>Built a symbolication system to parse crash logs for the Office MacOs/iOS Customer Insights team</li>
            </ul>
         </div>


         <div className="picDiv">
            <img src={Pop} className="imgHolder"/>
         </div>
         <div className="contentDiv">
            <h2>New Technologist Intern</h2>
            <h3>Microsoft</h3>
            <ul>
            <li>Built a polling and data visualization based social media platform utilizing React, Redux and Firebase</li>
            <li>Completed and applied a 75+ hour curriculum on the product life cycle including: user research, wireframing, spec reviews, and front-end web development, resulting in a final pitch to executives </li>
            </ul>
         </div>

         <div className="picDiv">
            <img src={Notification} className="imgHolder"/>
         </div>
         <div className="contentDiv">
            <h2>Intern - Hybrid Cloud Science Data System</h2>
            <h3>NASA Jet Propulsion Laboratory</h3>
            <ul>
            <li>Developed a Slackbot to identify idle AWS EC2 instances, saving $200 per data processing campaign</li>
            <li>Built a public-facing website using React, GatsbyJS, and GitHub Pages to accelerate user engagement</li>
            <li>Created a developer guide for the OCO-2 satellite team along with an open source contribution guide</li>
            </ul>
         </div>
         
         <div className="picDiv">
            <img src={PairProgram} className="imgHolder"/>
         </div>
         <div className="contentDiv">
            <h2>Computer Science Tutor</h2>
            <h3>Fullerton College</h3>
            <ul>
            <li>Worked as the designated student tutor for four courses: Data Structures and Algorithms in C++, Assembly Language and Computer Organization, C Programming for Science, and Introduction to C++ </li>
            <li>Assisted students in designing, debugging, and documenting various programming assignments</li>
            </ul>
         </div>

         <div className="picDiv">
            <img src={Math} className="imgHolder"/>
         </div>
         <div className="contentDiv">
            <h2>Calculus Supplemental Instructor</h2>
            <h3>Fullerton College</h3>
            <ul>
            <li>Facilitated bi-weekly review sessions to reinforce Mathematical concepts taught in class</li>
            <li>Created a collaborative and interactive learning environment to assist students in developing academic and interpersonal skills</li>
            <li>Worked alongside professors and faculty to develop Supplemental Instruction plans</li>
            </ul>
         </div>
       
      </div>
      </div>
   );

}

export default WorkExperience;